import { useEffect, useState } from "react";
import { Calculator as CalcIcon } from "lucide-react";
import api from "@/lib/api";
import { QuoteWizard } from "@/components/QuoteWizard";

export default function ManualQuote() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="manual-quote-page">
      <div>
        <h1 className="font-display text-2xl font-bold text-slate-900 flex items-center gap-2">
          <CalcIcon size={22} className="text-blue-900" /> Preventivo manuale
        </h1>
        <p className="text-sm text-slate-500 mt-1">Stesso calcolatore del cliente. Compila la tratta per generare un preventivo manualmente.</p>
      </div>
      <div className="max-w-2xl">
        {settings ? <QuoteWizard settings={settings} campaign="admin-manual" />
          : <div className="h-72 rounded-2xl bg-white border border-slate-200 animate-pulse" />}
      </div>
    </div>
  );
}
